import { useEffect, useCallback } from 'react'
import { useAuthStore } from '../stores/authStore'
import authService from '../services/authService'

export const useTokenRefresh = () => {
  const { token, refreshToken, isAuthenticated } = useAuthStore()

  const refreshAccessToken = useCallback(async () => {
    try {
      const result = await authService.refreshToken()
      if (result.success) {
        return result.token
      }
      throw new Error('Token refresh failed')
    } catch (error) {
      // refreshAccessToken() already ends the session on a 401; transient failures retry next tick
      console.error('Token refresh failed:', error)
      throw error
    }
  }, [])

  const checkTokenExpiry = useCallback(() => {
    if (!isAuthenticated || !token) return

    const isExpired = authService.isTokenExpired(token)
    if (isExpired && refreshToken) {
      refreshAccessToken().catch(() => {
        // Error already handled in refreshAccessToken
      })
    }
  }, [token, refreshToken, isAuthenticated, refreshAccessToken])

  // Check token expiry on mount and periodically
  useEffect(() => {
    if (!isAuthenticated) return

    // Check immediately
    checkTokenExpiry()

    // Check every 5 minutes
    const interval = setInterval(checkTokenExpiry, 5 * 60 * 1000)

    return () => clearInterval(interval)
  }, [isAuthenticated, checkTokenExpiry])

  return {
    refreshAccessToken,
    checkTokenExpiry
  }
}